export const defaultColumns = [
  {label: 'Status', value: 'status'}, 
  {label: 'Perfil', value: 'role'}, 
  {label: 'Nome', value: 'fullName'}, 
  {label: 'Último acesso', value: 'lastSeenAt', className: 'w-10'},
  {label: 'Ações', value: 'actions', className: 'w-10'},
]